import * as React from "react";
import {
  Button,
  Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper as MuiPaper,
  MenuItem,
  Select,
  CircularProgress,
  Checkbox,
  Tabs,
  Tab,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import Link from "@mui/material/Link";
import { NavLink, useNavigate } from "react-router-dom";
import { Box, spacing } from "@mui/system";
import styled from "@emotion/styled";
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import { useEffect } from "react";
import PropTypes from "prop-types";
import CreateCyclePaymentComponent from "../../Cobrancas/createcarne/cycle-payment";
import CreateFinePaymentComponent from "../../Cobrancas/createcarne/fine-payment";
import CreateDiscountPaymentComponent from "../../Cobrancas/createcarne/discount-payment";
import CreateNfsePaymentComponent from "../../Cobrancas/createcarne/nfse-payment";

export default function CarnemenuTabOptions({ createCompoment }) {
  let { getApi, postApi, user, signUpStep2, isBSAccount, isInitializedBS } =
    useAuth();
  const [tabVal, setTabVal] = React.useState(0);

  const handleChangeTabVal = (event, newValue) => {
    setTabVal(newValue);
  };

  return (
    <React.Fragment>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabVal}
            onChange={handleChangeTabVal}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Ciclos e Vencimentos" />
            <Tab label="Multa e Juros" />
            <Tab label="Desconto" />
            {!window.block_resources.includes("nfse") && (
              <Tab label="Nota Fiscal de Serviço" />
            )}
            {window.block_resources.includes("nfse") && (
              <Tab label="Nota Fiscal de Serviço (breve)" disabled={true} />
            )}
          </Tabs>
        </Box>

        <CustomTabPanel value={tabVal} index={0}>
          <CreateCyclePaymentComponent createCompoment={createCompoment} />
        </CustomTabPanel>

        <CustomTabPanel value={tabVal} index={1}>
          <CreateFinePaymentComponent createCompoment={createCompoment} />
        </CustomTabPanel>

        <CustomTabPanel value={tabVal} index={2}>
          <CreateDiscountPaymentComponent createCompoment={createCompoment} />
        </CustomTabPanel>

        {!window.block_resources.includes("nfse") && (
          <CustomTabPanel value={tabVal} index={3}>
            <CreateNfsePaymentComponent createCompoment={createCompoment} />
          </CustomTabPanel>
        )}
      </Box>
    </React.Fragment>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, marginTop: 2 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
